/* ============================================================
   ÉKO '77 — the footer's "Cookie preferences" button.

   The theme used to ship its own consent banner
   (snippets/x-cookie-banner.liquid + x-cookie-banner.js/.css) and this
   button opened it. That banner was removed: the store already runs
   Shopify's own banner from Settings → Customer privacy, which is on
   "Automated" — Shopify keeps its regions and copy in step with the
   markets the store sells in, and gates the pixels itself. Two banners
   on one page was the actual bug behind "the cookie thing keeps coming
   back", and of the two the platform's is the one that stays compliant
   without anybody maintaining it.

   So all that survives here is the wiring: the footer link is a real
   affordance visitors expect (and some regulations expect), and it has
   to open SOMETHING. Shopify's own preferences dialog is that something.

   The button stays a <button data-cookie-preferences-open> so the footer
   markup and its merchant settings (show_cookie_preferences /
   cookie_preferences_label) did not have to change.
   ============================================================ */

(function () {
  'use strict';

  var buttons = document.querySelectorAll('[data-cookie-preferences-open]');
  if (!buttons.length) return;

  /* window.privacyBanner is the object that owns the dialog — NOT
     Shopify.customerPrivacy, which is the consent-state API and has no
     showPreferences() at all on this shop (checked: it exposes
     getTrackingConsent / setTrackingConsent / shouldShowBanner and friends,
     and nothing that opens UI). privacyBanner ships with the native banner,
     so it is present whenever Settings → Customer privacy has it on.

     Bound on click rather than at load: the script is deferred and the
     banner's own bundle may still be arriving, and a visitor can click this
     at any point long after either has settled. */
  var open = function () {
    var pb = window.privacyBanner;
    if (pb && typeof pb.showPreferences === 'function') pb.showPreferences();
  };

  for (var i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener('click', open);
  }
})();
